import { getSumOfSeries } from './utils';

export default function transformDoubleChart({
  primaryChart: primary,
  secondaryChart: secondary,
  sameScale = false,
}) {
  const primaryChart = getSumOfSeries(primary);
  const secondaryChart = getSumOfSeries(secondary);
  const primaryTitle = primary.title;
  const secondaryTitle = secondary.title;

  const options = {
    yAxis: [
      {
        title: {
          text: primaryTitle,
        },
      },
      {
        title: {
          text: secondaryTitle,
        },
        opposite: true,
      },
    ],
  };
  if (!sameScale) secondaryChart.yAxis = 1;
  return {
    series: [primaryChart, secondaryChart],
    options,
  };
}
